<template>
  <div class="container">
    <div class="container py-4">
      <div class="alert alert-info" role="alert">
        {{ loading ? "Accesso in corso..." : "Redirect..." }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, onMounted } from "vue";
import {useRoute, useRouter} from "vue-router";
import {useToast} from "vue-toast-notification";
import useAuthStore from "@/stores/auth.store.js";
import useSettingsStore from "@/stores/settings.store.js";
import useThemeStore from "@/stores/theme.store.js";
import axios from "@/services/axios.setup.js"

const apiUrl = import.meta.env.VITE_API_URL;
const authStore = useAuthStore();
const settingsStore = useSettingsStore();
const router = useRouter();
const route = useRoute();
//route.query.token variabile get token
const theme = useThemeStore();
const tryAsync = inject('tryAsync');
const errorToast = inject('errorToast');

const loading = ref(true);
const errors = ref(null);



onMounted(async () => {
  // Caso A: il backend ti rimanda direttamente un token in query string
  const querydata = route.query.data;

  // Caso B: flusso OAuth classico: ricevi code/state e scambi il code col backend
  const code = route.query.code;
  const state = route.query.state;

  try {
    if (querydata && typeof querydata === 'string' && querydata.length) {
      const base64 = querydata.replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
      const json = atob(padded);
      let data = JSON.parse(json);

      if (data && data.needs_reset) {
        router.push('password/reset/' + data.password_reset_token)
        return;
      } else if (data && data.result === 'success') {
        authStore.setUser(data);
        router.push('/');
        return;
      } else {
        errorToast(data.message);
        return;
      }

    }

    if (code) {
      // Esempio: scambio code -> token/sessione tramite backend
      const { data } = await tryAsync(
          axios.post("/auth/azure/callback", { code, state }),
          "Errore nel callback SSO"
      );

      // Qui dipende dal payload del tuo backend (token, user, ecc.)
      authStore.setUser(data);
      await router.replace("/");
      return;
    }

    errorToast?.("Callback SSO non valido: parametri mancanti.");
    await router.replace("/login");
  } finally {
    loading.value = false;
  }
});

</script>

<style></style>
